import React, { useEffect, useState } from 'react';
import classes from './ProfilePage2.module.css';
import { getProfileApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { removeUserDetails } from '../../store/slices/userSlice';
import Header2 from '../../component/NewComponents/Header2';
import {
    FaFutbol,
    FaArrowRightFromBracket,
    FaPen,
    FaChevronRight,
    FaShield,
    FaTrophy,
    FaGift,
} from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

const MENU_ITEMS = [
    {
        icon: FaPen,
        label: "Edit Profile",
        sub: "Update your name, photo & info",
        path: "/edit-profile",
        color: "blue",
    },
    {
        icon: FaFutbol,
        label: "My Matches",
        sub: "View your prediction history",
        path: "/my-matches",
        color: "red",
    },
    {
        icon: FaTrophy,
        label: "Your Winnings",
        sub: "View your rewards",
        path: "/winnings",
        color: "gold",
    },
    {
        icon: FaGift,
        label: "Prizes",
        sub: "Prize Info",
        path: "/match-rewards-info",
        color: "gold",
    },
];

const MENU_ITEMS_SW = [
    {
        icon: FaPen,
        label: "Hariri Wasifu",
        sub: "Sasisha jina, picha na taarifa zako",
        path: "/edit-profile",
        color: "blue",
    },
    {
        icon: FaFutbol,
        label: "Mechi Zangu",
        sub: "Angalia historia ya utabiri wako",
        path: "/my-matches",
        color: "red",
    },
    {
        icon: FaTrophy,
        label: "Ushindi Wako",
        sub: "Angalia zawadi ulizoshinda",
        path: "/winnings",
        color: "gold",
    },
    {
        icon: FaGift,
        label: "Zawadi",
        sub: "Taarifa kuhusu zawadi",
        path: "/match-rewards-info",
        color: "gold",
    },
];

const ProfilePage2 = () => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const { userDetails } = useSelector(state => state.persisted?.userSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { selectedLanguage } = useSelector((state) => state.languageSlice);
    const { t } = useTranslation();

    const fetchUserProfile = async () => {
        try {
            setLoading(true);
            const response = await getProfileApi(userDetails?.token);
            setProfile(response?.data);
        } catch (error) {
            toast.error(
                error?.response?.data?.error?.error ||
                error?.response?.error?.error ||
                error?.response?.error ||
                t("2")
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchUserProfile(); }, []);

    const logoutHandler = () => {
        dispatch(removeUserDetails());
        navigate('/');
    };

    /* initials fallback */
    const initials = profile?.name
        ? profile.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
        : (userDetails?.msisdn?.slice(-2) ?? '?');

    return (
        <>
            <Header2 active={4} />

            <div className={classes.page}>
                <div className={classes.bgGlow} />
                <div className={classes.bgGrid} />

                <main className={classes.main}>

                    {/* ── Avatar hero ── */}
                    <div className={classes.avatarHero}>
                        {/* outer pulse ring */}
                        <div className={classes.avatarPulse} />

                        <div className={classes.avatarRing}>
                            {loading ? (
                                <div className={classes.avatarSkeleton} />
                            ) : profile?.image ? (
                                <img src={profile.image} alt={profile?.name} className={classes.avatarImg} />
                            ) : (
                                <div className={classes.avatarFallback}>
                                    <span className={classes.avatarInitials}>{initials}</span>
                                </div>
                            )}
                        </div>

                        {/* Verified / player badge */}
                        <div className={classes.playerBadge}>
                            <FaShield className={classes.playerBadgeIcon} />
                            <span>Vodacom {t("251")}</span>
                        </div>

                        {/* Name + msisdn */}
                        <div className={classes.avatarInfo}>
                            {loading ? (
                                <>
                                    <div className={classes.skeletonName} />
                                    <div className={classes.skeletonSub} />
                                </>
                            ) : (
                                <>
                                    <h1 className={classes.profileName}>
                                        {profile?.name || t("252")}
                                    </h1>
                                    <p className={classes.profileMsisdn}>
                                        {userDetails?.msisdn ?? ''}
                                    </p>
                                </>
                            )}
                        </div>
                    </div>

                    {/* ── Menu section ── */}
                    <div className={classes.section}>
                        <p className={classes.sectionLabel}>{t("253")}</p>
                        <div className={classes.menuCard}>
                            {(selectedLanguage == 0 ? MENU_ITEMS : MENU_ITEMS_SW).map((item, i) => {
                                const Icon = item.icon;
                                return (
                                    <React.Fragment key={item.label}>
                                        {i > 0 && <div className={classes.menuDivider} />}
                                        <button
                                            type="button"
                                            className={classes.menuRow}
                                            onClick={() => navigate(item.path)}
                                        >
                                            <div className={`${classes.menuIconBox} ${classes[`icon_${item.color}`]}`}>
                                                <Icon className={classes.menuIcon} />
                                            </div>
                                            <div className={classes.menuText}>
                                                <span className={classes.menuLabel}>{item.label}</span>
                                                <span className={classes.menuSub}>{item.sub}</span>
                                            </div>
                                            <FaChevronRight className={classes.menuChevron} />
                                        </button>
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>

                    {/* ── Logout ── */}
                    <div className={classes.section}>
                        <p className={classes.sectionLabel}>{t("254")}</p>
                        <button
                            type="button"
                            className={classes.logoutBtn}
                            onClick={logoutHandler}
                        >
                            <div className={classes.logoutIconBox}>
                                <FaArrowRightFromBracket className={classes.logoutIcon} />
                            </div>
                            <div className={classes.menuText}>
                                <span className={classes.logoutLabel}>{t("255")}</span>
                                <span className={classes.menuSub}>{t("256")}</span>
                            </div>
                            <FaChevronRight className={classes.menuChevron} />
                        </button>
                    </div>

                    {/* ── Footer note ── */}
                    <p className={classes.footerNote}>
                        Vodacom Football Predict · © {new Date().getFullYear()} Door2Future Consultants Pvt Ltd
                    </p>

                </main>
            </div>
        </>
    );
};

export default ProfilePage2;